// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {ActivityIndicator, Text} from 'trpc-react-native-ui';

import GradientPage from './GradientPage';
import FullButton from './FullButtons/FullButton';
import TertiaryFullButton from './FullButtons/TertiaryFullButton';
import SecondaryFullButton from './FullButtons/SecondaryFullButton';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import PasswordService from '../../lib/password';
import PageTitle from '../signUp/PageTitle';
import LoginForm from '../signUp/LoginForm';
import * as Navigation from '../../lib/navigation.js';

class GenericLogin extends Component<Props, {passwordProgress: number}> {
  styles = getStyles();
  state = { passwordProgress: 0 };

  componentDidMount() {
    const redirectPath = this.props.route.params?.redirect_to;
    if (redirectPath) {
      this.props.redirectAfterLogin &&
        this.props.redirectAfterLogin(redirectPath);
    }
  }

goToCreateAccount = () => {
    if (!this.props.goToCreateAccount) {
      return Navigation.navigate('requiredToSignUp');
    }
    this.props.goToCreateAccount();
  };

  goToResetPassword = () => Navigation.navigate('resetPassword');

  render() {
    const styles = this.styles;
    return this.props.isRedirectLoading ? (
      <ActivityIndicator style={styles.loading} />
    ) : (
      <GradientPage maxWidth={600} iosEdges={['top','bottom']}>
        <KeyboardAwareScrollView
          extraHeight={280}
          keyboardShouldPersistTaps="always"
          enableOnAndroid="true">
          <PageTitle title={I18n.t('signIn')} style={styles.title} />
          <View style={styles.form}>
            <View style={styles.errorContainer} testID="loginErrorMessage">
              {this.props.submitFailed && this.props.error && (
                <Text style={styles.error}>{this.props.error}</Text>
              )}
            </View>
            <LoginForm
              handleSubmit={this.props.handleSubmit}
              emailTestID={'emailDuringLogin'}
              passwordTestID={'passwordDuringLogin'}
              onPasswordStrengthChange={(progress) => this.setState({ passwordProgress: progress })}
            />
            <TertiaryFullButton
              text={I18n.t('forgotPassword')}
              onPress={this.goToResetPassword}
              style={styles.forgotPasswordLink}
              testID="forgotPasswordLink"
            />
            <FullButton
              text={I18n.t('validate')}
              onPress={this.props.handleSubmit}
              isLoading={this.props.isLoading}
              testID="loginSubmitButton"
            />
            {!this.props.disableCreateAccount && (
              <SecondaryFullButton
                text={I18n.t('dontHaveAccount')}
                onPress={this.goToCreateAccount}
                style={styles.alreadyHaveAccountLink}
                testID={'dontHaveAccountLink'}
              />
            )}
          </View>
        </KeyboardAwareScrollView>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    title: {
      marginHorizontal: 35,
    },
    form: {
      marginTop: 60,
      marginBottom: 105,
      marginHorizontal: 20,
    },
    errorContainer: {
      justifyContent: 'center',
      height: 40,
      marginVertical: 10,
    },
    error: {
      color: theme.primaryColor,
      backgroundColor: 'transparent',
      fontSize: 16,
      textAlign: 'center',
    },
    forgotPasswordLink: {
      color: theme.signUpTransparentTextColor,
      marginTop: 10,
      marginBottom: 47,
    },
    alreadyHaveAccountLink: {
      marginTop: 15,
      color: theme.signUpTextColor,
    },
    loading: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

type Props = DispatchProps & StateProps & OwnProps;

export type DispatchProps = {
  goToCreateAccount?: Function,
  disableCreateAccount?: boolean,
  redirectAfterLogin?: Function,
};

export type StateProps = {
  isRedirectLoading?: boolean,
  isLoading: boolean,
};

export type OwnProps = {
  error: any,
  handleSubmit: Function,
  route: NavigationScreenProp<NavigationRoute>,
  submitFailed: boolean,
};

export default GenericLogin;
